import {
    DatePickerInput as MantineDatePickerInput,
    DatePickerInputProps as MantineDatePickerInputProps,
} from '@mantine/dates';
import { FC } from 'react';

import inputStyles from '../../styles/Input.module.css';
import datePickerStyles from '../styles/DatePicker.module.css';

import { CalendarIcon } from '../../../icons/CalendarIcon';
import { handleGetDayProps, handleGetMonthControlProps, handleGetYearControlProps } from '../utils';

export type DatePickerInputProps = MantineDatePickerInputProps;

export const DatePickerInput: FC<DatePickerInputProps> = ({ type = 'default', ...rest }) => {
    return (
        <MantineDatePickerInput
            placeholder="Pick date"
            valueFormat="MM/DD/YYYY"
            classNames={{
                input: inputStyles.input,
                label: inputStyles.label,
                description: inputStyles.description,
                required: inputStyles.required,
                placeholder: inputStyles.placeholder,
                day: datePickerStyles.day,
                monthCell: datePickerStyles.monthCell,
                calendarHeaderLevel: datePickerStyles.calendarHeaderLevel,
                monthsListControl: datePickerStyles.monthsListControl,
                yearsListControl: datePickerStyles.yearsListControl,
            }}
            /**
             * TODO: Add support for different non tabular icon colors based on input state, i.e disabled, error, etc
             */
            rightSection={<CalendarIcon />}
            getDayProps={handleGetDayProps}
            getYearControlProps={handleGetYearControlProps}
            getMonthControlProps={handleGetMonthControlProps}
            type={type}
            rightSectionPointerEvents="none"
            {...(rest as MantineDatePickerInputProps<typeof type>)}
        />
    );
};
